import { elakay_API } from '../../config';

const request = async (path, token, body, method = 'GET') => {
  const response = await fetch(`${elakay_API}${path}`, {
    method,
    headers: { Accept: 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}), ...(body ? { 'Content-Type': 'application/json' } : {}) },
    ...(body ? { body: JSON.stringify(body) } : {}),
  });
  const data = await response.json();
  if (!response.ok || data.success === false) throw Object.assign(new Error(data.code || (response.status === 401 ? 'AUTHENTICATION_REQUIRED' : 'TOKEN_INVALID')), { code: data.code || (response.status === 401 ? 'AUTHENTICATION_REQUIRED' : 'TOKEN_INVALID') });
  return data;
};
export const getRoleTokenSettings = token => request('/user/role-token/settings', token);
export const getTokenOpportunities = token => request(`/user/promoToken/opportunities?t=${encodeURIComponent(token)}`);
export const configureRoleToken = (token, pubId, config) => request(`/user/promoToken/${encodeURIComponent(pubId)}/configuration`, token, config, 'PUT');
export const createEventRoleToken = (token, config) => request('/user/eventRoleToken', token, config, 'POST');
export const acceptEventRoleToken = (token, config) => request('/user/eventRoleToken/accept', token, config, 'POST');
export const getEventRoleApplicationStatus = (token, eventToken) => request(`/user/eventRoleToken/application-status?t=${encodeURIComponent(eventToken)}`, token);
export const getEventRoleApplicationCategories = (eventToken, query = {}) => request(`/user/eventRoleToken/application-categories?t=${encodeURIComponent(eventToken)}&${new URLSearchParams(query)}`);

export const deleteEventRoleToken = (token, pubId) => request(`/user/eventRoleToken/${encodeURIComponent(pubId)}`, token, null, 'DELETE');
